export default [
  [
    // Графит
    {
      title: 'Какая формула соответствует данному веществу?',
      answers: [
        'С',
        'У',
        'Г',
      ],
      rightAnswer: 1,
    },
    {
      title: 'Какими свойствами обладает данное вещество? Выбери несколько вариантов ответа.',
      answers: [
        'Проводит ток',
        'Расслаивается на отдельные чешуйки',
        'Относительно твердый',
      ],
      rightAnswer: '12',
    },
    {
      title: 'Оцени растворимость вещества:',
      answers: [
        'Хорошо растворимо',
        'Мало растворимо',
        'Нерастворимо',
      ],
      rightAnswer: 3,
    },
    {
      title: 'Определи класс вещества:',
      answers: [
        'Простое вещество',
        'Оксид',
        'Основание',
        'Кислота',
        'Соль',
      ],
      rightAnswer: 1,
    },
  ],
  [
    // Медный купорос
    {
      title: 'Какая формула соответствует данному веществу?',
      answers: [
        'CuSO<sub>4</sub>',
        'CuSO<sub>4</sub>*5H<sub>2</sub>O',
        'CuSO<sub>4</sub>*10H<sub>2</sub>O',
      ],
      rightAnswer: 2,
    },
    {
      title: 'Какими свойствами обладает данное вещество? Выбери несколько вариантов ответа.',
      answers: [
        'Проводит ток',
        'Синий цвет',
        'При нагревании выделяет воду',
      ],
      rightAnswer: '23',
    },
    {
      title: 'Оцени растворимость вещества:',
      answers: [
        'Хорошо растворимо',
        'Мало растворимо',
        'Нерастворимо',
      ],
      rightAnswer: 1,
    },
    {
      title: 'Определи класс вещества:',
      answers: [
        'Простое вещество',
        'Оксид',
        'Основание',
        'Кислота',
        'Соль',
      ],
      rightAnswer: 5,
    },
  ],
  [
    // Гидроксид меди
    {
      title: 'Какая формула соответствует данному веществу?',
      answers: [
        'CuOH',
        'Cu(OH)<sub>2</sub>',
        'CuOOH',
      ],
      rightAnswer: 2,
    },
    {
      title: 'Какими свойствами обладает данное вещество? Выбери несколько вариантов ответа.',
      answers: [
        'Может образовывать кристаллы',
        'Синий цвет',
        'Не проводит ток',
      ],
      rightAnswer: '123',
    },
    {
      title: 'Оцени растворимость вещества:',
      answers: [
        'Хорошо растворимо',
        'Мало растворимо',
        'Нерастворимо',
      ],
      rightAnswer: 3,
    },
    {
      title: 'Определи класс вещества:',
      answers: [
        'Простое вещество',
        'Оксид',
        'Основание',
        'Кислота',
        'Соль',
      ],
      rightAnswer: 3,
    },
  ],
  [
    // Песок
    {
      title: 'Какая формула соответствует данному веществу?',
      answers: [
        'Si',
        'SiO',
        'SiO<sub>2</sub>',
      ],
      rightAnswer: 3,
    },
    {
      title: 'Какими свойствами обладает данное вещество? Выбери несколько вариантов ответа.',
      answers: [
        'Не проводит ток',
        'Высокая прочность',
        'Относительно твердое',
      ],
      rightAnswer: '13',
    },
    {
      title: 'Оцени растворимость вещества:',
      answers: [
        'Хорошо растворимо',
        'Мало растворимо',
        'Нерастворимо',
      ],
      rightAnswer: 3,
    },
    {
      title: 'Определи класс вещества:',
      answers: [
        'Простое вещество',
        'Оксид',
        'Основание',
        'Кислота',
        'Соль',
      ],
      rightAnswer: 2,
    },
  ],
  [
    // Серная кислота
    {
      title: 'Какая формула соответствует данному веществу?',
      answers: [
        'H<sub>2</sub>SO<sub>3</sub>',
        'H<sub>2</sub>SO<sub>4</sub>',
        'H<sub>2</sub>S<sub>2</sub>O<sub>5</sub>',
      ],
      rightAnswer: 2,
    },
    {
      title: 'Какими свойствами обладает данное вещество?',
      answers: [
        'Пахнет серой',
        'Жидкость',
        'Проводит ток',
      ],
      rightAnswer: '2',
    },
    {
      title: 'Определи класс вещества:',
      answers: [
        'Простое вещество',
        'Оксид',
        'Основание',
        'Кислота',
        'Соль',
      ],
      rightAnswer: 4,
    },
    // {
    //   title: 'Оцени, смешиваются они или нет:',
    //   answers: [
    //     'Смешиваются',
    //     'Не смешиваются',
    //   ],
    //   rightAnswer: 1,
    // },
  ],
]
